import { ApiEnvironment } from '../../models/api-environment';

export class TrimbleIdentityEnvironment extends ApiEnvironment {
  get authorizeUrl() {
    return `${this.baseUrl}/oauth/authorize`;
  }

  get userInfoUrl() {
    return `${this.baseUrl}/oauth/userinfo`;
  }

  get tokenUrl() {
    return `${this.baseUrl}/oauth/token`;
  }

  get logoutUrl() {
    return `${this.baseUrl}/oauth/logout`;
  }

  override resolve(environment: unknown) {
    return environment instanceof TrimbleIdentityEnvironment
      ? environment
      : this;
  }
}

export const trimbleIdentityEnvironment = new TrimbleIdentityEnvironment();
